var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodeLocalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg6098",
    viewBox: "0 0 20 20",
    height: 27,
    width: 27,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6102"
  })), /*#__PURE__*/React.createElement("path", {
    shapeRendering: "geometricPrecision",
    style: {
      fill: "#061e37",
      strokeWidth: 0.80740714
    },
    d: "m 14.49526,13.323829 0.934236,0.934207 H 18.8993 c 0.243245,0 0.440397,0.196948 0.440397,0.440236 v 3.963679 c 0,0.243289 -0.197164,0.440237 -0.440397,0.440237 h -3.96364 c -0.243243,0 -0.440395,-0.196948 -0.440395,-0.440237 v -3.469818 l -0.934241,-0.934097 h -3.469806 c -0.2432449,0 -0.440403,-0.196948 -0.440403,-0.440237 V 9.8541218 c 0,-0.2432886 0.197164,-0.4402365 0.440403,-0.4402365 h 3.963635 c 0.243217,0 0.440403,0.1969479 0.440403,0.4402365 z m -3.523235,-2.589068 v 2.202067 h 2.202018 v -2.202067 z m 4.844444,4.844482 v 2.201958 h 2.202021 v -2.201958 z",
    id: "path3857"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeLocalIcon);
export default __webpack_public_path__ + "static/media/node-local-icon.39dc2050aae7b27ab0c77dc24dbdbaf0.svg";
export { ForwardRef as ReactComponent };